import Badge from "../components/Badge";
import BaseAlert from "../components/BaseAlert";
import BaseButton from "../components/BaseButton";
import BaseCheckbox from "../components/BaseCheckbox";
import BaseInput from "../components/BaseInput";
import BasePagination from "../components/BasePagination";
import BaseProgress from "../components/BaseProgress";
import BaseRadio from "../components/BaseRadio";
import BaseSlider from "../components/BaseSlider";
import BaseSwitch from "../components/BaseSwitch";
import Card from "../components/Card";
import Icon from "../components/Icon";
import BaseSelect from "../components/BaseSelect.vue";
import Modal from "../components/Modal.vue";
import flatPicker from "vue-flatpickr-component";
import BaseNav from "../components/BaseNav.vue"
import BaseDropdown from "../components/BaseDropdown.vue"
import CloseButton from "../components/CloseButton.vue"
import Message from "../components/Message.vue"
import RoundIcon from "../components/RoundIcon.vue"

export default {
  install(Vue) {
    Vue.component(Badge.name, Badge);
    Vue.component(BaseAlert.name, BaseAlert);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BasePagination.name, BasePagination);
    Vue.component(BaseProgress.name, BaseProgress);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(BaseSlider.name, BaseSlider);
    Vue.component(BaseSwitch.name, BaseSwitch);
    Vue.component(Card.name, Card);
    Vue.component(Icon.name, Icon);
    Vue.component(BaseSelect.name, BaseSelect);
    Vue.component(Modal.name, Modal);
    Vue.component(BaseNav.name, BaseNav);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(CloseButton.name, CloseButton);
    Vue.component(Message.name, Message);
    Vue.component(flatPicker);
    Vue.component(RoundIcon.name, RoundIcon)
  }
};
